import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import * as serviceWorker from './serviceWorker';
import { store, persistor } from './store';
import mapboxgl from 'mapbox-gl';
import TagManager, { TagManagerArgs } from 'react-gtm-module';
import SessionManager from './utils/SessionManager';

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_PUBLIC_TOKEN;

const tagManagerArgs: TagManagerArgs = {
    gtmId: process.env.REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID,
};
TagManager.initialize(tagManagerArgs);

ReactDOM.render(
    <React.StrictMode>
        <ErrorBoundary>
            <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ''}>
                <Router>
                    <Provider store={store}>
                        <PersistGate loading={null} persistor={persistor}>
                            <SessionManager/>
                            <App/>
                        </PersistGate>
                    </Provider>
                </Router>
            </GoogleOAuthProvider>
        </ErrorBoundary>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
